import { Component, computed, input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { KonverteringGridComponent } from '../konvertering-grid/konvertering-grid.component';
import { KonverteringDetailComponent } from '../konvertering-detail/konvertering-detail.component';

@Component({
  selector: 'app-konvertering',
  imports: [TableModule, KonverteringGridComponent, KonverteringDetailComponent],
  templateUrl: './konvertering-main.component.html',
  styleUrl: './konvertering-main.component.css',
})
export class KonverteringMainComponent {
  id = input<string>();
  konverteringId = computed(() => Number(this.id()));
}
